<div class="form-check pe-2">
  <input class="form-check-input" type="checkbox" id="agreeTerms" [(ngModel)]="agreeTerms" (change)="checkboxChanged.emit(agreeTerms)" />
  <label class="form-check-label" for="agreeTerms" [innerHTML]="textHtml">
  </label>
</div>